export const auth = {
  login: "/auth/login",
  signUp: "/auth/signup",
  resetPassword: "/account/sendResetPassword",
  status: "/account/me",
};

export const cart = "/cart";

export const routes = {
  postLoginRedirect: "/home",
};
